import { render } from "./LilaPopUpAlert.vue?vue&type=template&id=122a913c&scoped=true"
import script from "./LilaPopUpAlert.vue?vue&type=script&lang=js"
export * from "./LilaPopUpAlert.vue?vue&type=script&lang=js"

import "./LilaPopUpAlert.vue?vue&type=style&index=0&id=122a913c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-122a913c"]])

export default __exports__